"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var articleApi = _interopRequireWildcard(require("@/api/article.js"));
var categoryApi = _interopRequireWildcard(require("@/api/categoryApi.js"));
var selfUtil = _interopRequireWildcard(require("@/utils/ZBKJIutil.js"));
var _edit = _interopRequireDefault(require("./edit"));
var _MultiLangArticleMaintain = _interopRequireDefault(require("@/components/i18n/MultiLangArticleMaintain.vue"));
var _permission = require("@/utils/permission");
var systemConfigApi = _interopRequireWildcard(require("@/api/systemConfig"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  // name: "list",
  components: {
    edit: _edit.default,
    MultiLangArticleMaintain: _MultiLangArticleMaintain.default
  },
  props: {
    bizType: {
      default: 1,
      //默认1：新闻/文章
      type: Number
    },
    //配合bizType==99使用客户自定义的各个模块
    customTag: {
      default: "",
      type: String
    },
    jumpWay: {
      default: 'newPage',
      //dialog
      type: String
    }
  },
  data: function data() {
    return {
      constants: this.$constants,
      listPram: {
        keywords: null,
        cid: null,
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      listData: {
        recordList: [],
        recordCount: 0
      },
      editDialogConfig: {
        visible: false,
        editData: {},
        isEdit: 0 // 0=add 1=edit
      },
      listLoading: true,
      categoryTreeData: [],
      categoryProps: {
        value: "id",
        label: "name",
        children: "child",
        expandTrigger: "hover",
        checkStrictly: true,
        emitPath: false
      },
      customConfig: {},
      showLanguageBtn: false,
      i18nPageDataVersion: 0
    };
  },
  computed: {
    currentPageBizIds: function currentPageBizIds() {
      return (this.listData.recordList || []).map(function (item) {
        return item.id;
      }).filter(Boolean);
    }
  },
  mounted: function mounted() {
    var _this = this;
    if ((0, _permission.checkPermi)(['admin:system:language'])) {
      this.showLanguageBtn = true;
    }
    this.handlerGetListData(this.listPram);
    this.handlerGetTreeList();
    systemConfigApi.customConfig().then(function (data) {
      _this.customConfig = data;
      console.log(_this.customConfig.packages);
    });
  },
  methods: {
    edit: function edit(item) {
      console.log(item);
      this.handlerOpenEdit(1, item);
    },
    handlerGetTreeList: function handlerGetTreeList() {
      var _this2 = this;
      categoryApi.listCategroy({
        type: 3,
        status: ""
      }).then(function (data) {
        _this2.categoryTreeData = data.recordList;
        localStorage.setItem("articleClass", JSON.stringify(data.recordList));
      });
    },
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      this.handlerGetListData(this.listPram);
    },
    handlerGetListData: function handlerGetListData(pram) {
      var _this3 = this;
      this.listLoading = true;
      articleApi.ListArticle(pram).then(function (data) {
        _this3.listData = data;
        _this3.i18nPageDataVersion += 1;
        _this3.listLoading = false;
      });
    },
    handlerOpenEdit: function handlerOpenEdit(isEdit, editData) {
      // 0=add 1=edit
      if (isEdit === 1) {
        this.editDialogConfig.isEdit = 1;
        this.editDialogConfig.editData = editData;
      } else {
        this.editDialogConfig.isEdit = 0;
      }
      this.editDialogConfig.visible = true;
    },
    // handlerGetCategoryTreeData() {
    //   const _pram = { type: constants.categoryType[2].value, status: 1 }
    //   categoryApi.treeCategroy(_pram).then(data => {
    //     this.categoryTreeData = selfUtil.addTreeListLabelForCasCard(data)
    //   })
    // },
    handlerHideDialog: function handlerHideDialog() {
      this.handlerGetListData(this.listPram);
      this.editDialogConfig.visible = false;
    },
    handlerDelete: function handlerDelete(rowData) {
      var _this4 = this;
      this.$confirm("确定删除当前数据", "提示").then(function (result) {
        articleApi.DelArticle(rowData).then(function (data) {
          _this4.$message.success("删除数据成功");
          _this4.handlerGetListData(_this4.listPram);
        });
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData(this.listPram);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData(this.listPram);
    }
  }
};